const styles = theme => ({
  flex: {
    display: 'flex'
  }
});

export default styles;
